import { render, staticRenderFns } from "./editNormalGoods.vue?vue&type=template&id=cf806cbe&scoped=true"
import script from "./editNormalGoods.vue?vue&type=script&lang=js"
export * from "./editNormalGoods.vue?vue&type=script&lang=js"
import style0 from "./editNormalGoods.vue?vue&type=style&index=0&id=cf806cbe&prod&scoped=true&lang=css"
import style1 from "./editNormalGoods.vue?vue&type=style&index=1&id=cf806cbe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf806cbe",
  null
  
)

export default component.exports